// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--3uQTR","post":"blog-module--post--2PWe7"};